import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "self-stretch pb-1 flex-col justify-start items-start gap-2 flex"
}
const _hoisted_2 = { class: "self-stretch justify-start items-center gap-3 inline-flex" }
const _hoisted_3 = {
  key: 1,
  class: "grow shrink basis-0 text-racq-dark-grey text-lg-bold"
}
const _hoisted_4 = { class: "self-stretch flex-col justify-start items-start flex border-racq-pale-blue-border gap-3" }

import { Field } from '@sitecore-jss/sitecore-jss-vue';
import BaseIcon from '../BaseIcon/BaseIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleReviewSummary',
  props: {
    title: {},
    icon: {},
    multiple: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border-racq-pale-blue-border flex flex-col basis-full first:rounded-t-lg last:rounded-b-lg max-w-176 bg-racq-true-white", 
      _ctx.multiple
        ? 'group first:border-t-[1.5px] border-t border-x-[1.5px] last:border-b-[1.5px]'
        : 'shadow-md border-[1.5px]'
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["self-stretch px-5 md:px-8 border-racq-pale-blue-border flex-col justify-start items-start gap-2.5 flex", {
        'py-5 group-first:pt-6 group-last:pb-6': _ctx.multiple,
        'py-6': !_ctx.multiple,
      }])
    }, [
      (_ctx.icon?.value || _ctx.title.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.icon?.value)
                ? (_openBlock(), _createBlock(BaseIcon, {
                    key: 0,
                    iconClass: _ctx.icon.value,
                    iconSize: "w-[20px] h-[20px]"
                  }, null, 8, ["iconClass"]))
                : _createCommentVNode("", true),
              (_ctx.title.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.title.value), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "reviewSummaryItems")
      ])
    ], 2)
  ], 2))
}
}

})